/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketStatus } from './TicketStatus';
import {
    TicketStatusFromJSON,
    TicketStatusFromJSONTyped,
    TicketStatusToJSON,
    TicketStatusToJSONTyped,
} from './TicketStatus';

/**
 * 
 * @export
 * @interface AsyncTicketCreatedRepresentation
 */
export interface AsyncTicketCreatedRepresentation {
    /**
     * 
     * @type {string}
     * @memberof AsyncTicketCreatedRepresentation
     */
    ticketId?: string;
    /**
     * 
     * @type {TicketStatus}
     * @memberof AsyncTicketCreatedRepresentation
     */
    status?: TicketStatus;
    /**
     * 
     * @type {Date}
     * @memberof AsyncTicketCreatedRepresentation
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AsyncTicketCreatedRepresentation
     */
    pollUrl?: string;
    /**
     * 
     * @type {Date}
     * @memberof AsyncTicketCreatedRepresentation
     */
    expiresAt?: Date | null;
}



/**
 * Check if a given object implements the AsyncTicketCreatedRepresentation interface.
 */
export function instanceOfAsyncTicketCreatedRepresentation(value: object): value is AsyncTicketCreatedRepresentation {
    return true;
}

export function AsyncTicketCreatedRepresentationFromJSON(json: any): AsyncTicketCreatedRepresentation {
    return AsyncTicketCreatedRepresentationFromJSONTyped(json, false);
}

export function AsyncTicketCreatedRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AsyncTicketCreatedRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'ticketId': json['ticketId'] == null ? undefined : json['ticketId'],
        'status': json['status'] == null ? undefined : TicketStatusFromJSON(json['status']),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'pollUrl': json['pollUrl'] == null ? undefined : json['pollUrl'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
    };
}

export function AsyncTicketCreatedRepresentationToJSON(json: any): AsyncTicketCreatedRepresentation {
    return AsyncTicketCreatedRepresentationToJSONTyped(json, false);
}

export function AsyncTicketCreatedRepresentationToJSONTyped(value?: AsyncTicketCreatedRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ticketId': value['ticketId'],
        'status': TicketStatusToJSON(value['status']),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'pollUrl': value['pollUrl'],
        'expiresAt': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
    };
}

